<script>
import PopupModal from './PopupModal.vue'
export default {
  name: 'AddToCartDialogue',
  components: { PopupModal },
   data: () => ({
        // Parameters that change depending on the type of dialogue
        product: {
            product_image: [],
            product_name: '',
        },
        status: 'success',
        message: '', // Main text content
 
        
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),
  created () {
   
  },
  methods: {
    show(opts = {}) {
            this.product = opts.product
            this.message = opts.message
            this.status = opts.status
           
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },
  }
}
</script>

<template>

    <!-- MODAL AREA START (Add To Cart Modal) -->
      <popup-modal ref="popup">
          <div class="modal-content ltn__modal-area ltn__add-to-cart-modal-area"  v-if="product">
                        <div class="modal-header">
                            <button type="button" class="close" @click="_confirm()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                             <div class="ltn__quick-view-modal-inner">
                                 <div class="modal-product-item">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="modal-product-img">
                                                <img :src="product.product_image[0]" alt="#">
                                            </div>
                                             <div class="modal-product-info">
                                                <h5><a href="product-details.html">{{ product.product_name }}</a></h5>
                                                <p class="added-cart">
                                                    <i v-if="status == 'success'" class="fa fa-check-circle"></i>  {{ message == '' ? 'Successfully added to your Cart' : message}}</p>
                                                <div class="btn-wrapper">
                                                    <router-link to="/cart" class="theme-btn-1 btn btn-effect-1">View Cart</router-link>
                                                    <router-link to="/checkout" class="theme-btn-2 btn btn-effect-2">Checkout</router-link>
                                                </div>
                                             </div>
                                             <!-- additional-info -->
                                             <div class="additional-info d-none">
                                                <p>We want to give you <b>10% discount</b> for your first order, <br>  Use discount code at checkout</p>
                                                <div class="payment-method">
                                                    <img src="/static/img/icons/payment.png" alt="#">
                                                </div>
                                             </div>
                                        </div>
                                    </div>
                                 </div>
                             </div>
                        </div>
                    </div>

     </popup-modal>
    <!-- MODAL AREA END -->
</template>
<style>
.modal-content
{
    border: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/AddToCartDialogue.vue